import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { session } from '../../../services/session';

import './editor.scss';

class Editor extends Component {
  constructor(props) {
    super(props);

    this.orgPath =
      session.userRole === 'admin' || session.userRole === 'product_match'
        ? 'admin'
        : `publisher/${session.orgId}`;

    this.state = {
      smartlinkId: '',
    };
  }

  onInput(event) {
    this.setState({ smartlinkId: event.target.value });
  }

  render() {
    return (
      <div className="editor">
        <h2 className="header">Smartlink Management</h2>
        <div className="editor-nav">
          <input
            type="text"
            value={this.state.smartlinkId}
            placeholder="Enter a Smartlink ID"
            onChange={this.onInput.bind(this)}
          />
          <Link
            className={`${!this.state.smartlinkId ? 'disabled' : ''}`}
            to={`/v2/${this.orgPath}/smartlinks/${this.state.smartlinkId}/edit`}
          >
            Edit Link
          </Link>
        </div>
      </div>
    );
  }
}

export default Editor;
